import React, { ReactNode } from 'react';
import saLang from '../shared/localization/entries/it_IT';
import {FaRegHospital, FaBriefcaseMedical, FaFileContract, FaClipboardList} from 'react-icons/fa';
import {FiUsers} from 'react-icons/fi';
import {BiSearchAlt} from 'react-icons/bi';
import { BsFillFileEarmarkPersonFill, BsBookmarkCheckFill } from 'react-icons/bs';
import {
  MdOutlineManageAccounts,
  MdHeadsetMic,
  MdOutlinePriceChange,
  MdOutlineEvent,
  MdOutlineEventNote,
  MdHome,
  MdOutlineMap
} from 'react-icons/md';
import { RiHospitalFill } from "react-icons/ri"
import {ImProfile} from 'react-icons/im';
import {IoAdd} from 'react-icons/io5';
import {RoutePermittedRole} from 'shared/constants/AppConst';
import { TbDeviceHeartMonitor } from 'react-icons/tb';
import { routePaths } from './hp';


export interface NavItemProps {
  id: string;
  messageId: keyof typeof saLang.messages;
  title: string;
  icon?: string | ReactNode;
  exact?: boolean;
  url?: string;
  // type?: string;
  type: 'item' | 'group' | 'collapse' | 'divider';
  count?: number;
  color?: string;
  auth?: string[];
  children?: NavItemProps[] //| NavItemProps;
  state: object;
}

export const CatalogIcon = () => (
    <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="none"
            strokeWidth={2}
            d="M5,6 L1,4.5 L1,18.443038 L12,23 L23,18.443038 L23,4 L19,6 M5,16 L5,2 L12,5 L19,2 L19,16 L12,19 L5,16 Z M11.95,5 L11.95,19"
        />
    </svg>
);

const HomePointsMenu: NavItemProps = {
  id: 'HomePoints',
  title: 'Home Points',
  messageId: '_hp.homepoints.sidebarGroupLabel',
   type: 'collapse',
//  type: 'group',
  icon: <RiHospitalFill />,//icona
  auth: [
    RoutePermittedRole.Gestore,
    RoutePermittedRole.Amministrativo,
    RoutePermittedRole.Freelancer,
  ],
  state: {},
  children: [
    {
      id: 'ListHomePoints',
      title: 'Home Points List',
      messageId: '_hp.homepoints.list.sidebarGroupLabel',
      type: 'item',
      url: '/elencoAmbulatori',
      icon: <BiSearchAlt/>,
      auth: [
        RoutePermittedRole.Gestore,
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
    {
      id: 'NewHomePoint',
      title: 'New Home Point',
      messageId: '_hp.homepoints.new.sidebarGroupLabel',
      type: 'item',
      url: '/aggiungiAmbulatorio',
      icon: <IoAdd/>,
      auth: [
        RoutePermittedRole.Gestore,
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    }],
}
const ContrattiMenu: NavItemProps = {
  id: 'GestioneContratti',
  title: 'Gestione Contratti',
  messageId: '_hp.contract.sidebarLabel',
   type: 'collapse',
//  type: 'group',
  icon: <FaFileContract/>,
  auth: [
    RoutePermittedRole.Gestore,
    // RoutePermittedRole.Amministrativo,
    RoutePermittedRole.Freelancer,
  ],
  state: {},
  children: [
    {
      id: 'ContractsList',
      title: 'Contracts List',
      messageId: '_hp.contractList.sidebarLabel',
      type: 'item',
      url: '/elencoContratti',
      icon: <BiSearchAlt/>,
      auth: [
        RoutePermittedRole.Gestore,
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
    {
      id: 'NewContract',
      title: 'New Contract',
      messageId: '_hp.newContract.sidebarLabel',
      type: 'item',
      url: '/nuovoContratto',
      icon: <IoAdd/>,
      auth: [
        RoutePermittedRole.Gestore,
      ],
      state: {},
    },
  ],
}

const AreaPartnerMenu: NavItemProps = {
  id: 'AreaPartners',
  title: 'Area Partrner',
  messageId: '_hp.areaPartner.sidebarGroupLabel',
   type: 'collapse',
//  type: 'group',
  icon: <FaRegHospital/>,
  auth: [
    RoutePermittedRole.Amministrativo,
    RoutePermittedRole.Freelancer,
  ],
  state: {},
  children: [
    {
      id: 'PartnerList',
      title: 'Elenco Partners',
      messageId: '_hp.listaPartners.sidebarLabel',
      type: 'item',
      url: '/elencoPartners',
      icon: <BiSearchAlt/>,
      auth: [
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
    HomePointsMenu,
    ContrattiMenu,
    {
      id: 'SlotManager',
      title: 'Configurazione slot',
      messageId: '_hp.slotConfig.sidebarLabel',
      type: 'item',
      url: '/gestioneSlot',
      icon: <MdOutlineEvent/>,
      auth: [
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
    {
      id: 'CataloghiManager',
      title: 'Configurazione cataloghi',
      messageId: '_hp.gestioneCataloghi.sidebarLabel',
      type: 'item',
      url: routePaths.cataloghi.gestione,
      icon: <CatalogIcon/>,
      auth: [
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
    {
      id: 'ListiniManager',
      title: 'Configurazione listini',
      messageId: '_hp.gestioneListini.sidebarLabel',
      type: 'item',
      url: '/elencoListini',
      icon: <MdOutlinePriceChange/>,
      auth: [
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
  ],
}

const PartnersMenu: NavItemProps = {
  id: 'GestionePartners',
  title: 'Gestione Partrner',
  messageId: '_hp.gestionePartners.sidebarGroupLabel',
   type: 'collapse',
//  type: 'group',
  icon: <FaRegHospital/>,
  auth: [
    RoutePermittedRole.Gestore,
  ],
  state: {},
  children: [
    {
      id: 'PartnerList',
      title: 'Elenco Partners',
      messageId: '_hp.listaPartners.sidebarLabel',
      type: 'item',
      url: '/elencoPartners',
      icon: <BiSearchAlt/>,
      auth: [
        RoutePermittedRole.Gestore,
      ],
      state: {},
    },
    {
      id: 'PartnerRegister',
      title: 'Partner Register',
      messageId: '_hp.registraPartners.sidebarLabel',
      type: 'item',
      url: '/registraPartner',
      icon: <IoAdd/>,
      auth: [
        RoutePermittedRole.Gestore,
      ],
      state: {},
    },
    HomePointsMenu,
    ContrattiMenu,
    {
      id: 'SlotManager',
      title: 'Configurazione slot',
      messageId: '_hp.slotConfig.sidebarLabel',
      type: 'item',
      url: '/gestioneSlot',
      icon: <MdOutlineEvent/>,
      auth: [
        RoutePermittedRole.Gestore,
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
    {
      id: 'CataloghiManager',
      title: 'Configurazione cataloghi',
      messageId: '_hp.gestioneCataloghi.sidebarLabel',
      type: 'item',
      url: routePaths.cataloghi.gestione,
      icon: <CatalogIcon/>,
      auth: [
        RoutePermittedRole.Gestore,
      ],
      state: {},
    },
    {
      id: 'ListiniManager',
      title: 'Configurazione listini',
      messageId: '_hp.gestioneListini.sidebarLabel',
      type: 'item',
      url: '/elencoListini',
      icon: <MdOutlinePriceChange/>,
      auth: [
        RoutePermittedRole.Gestore,
        RoutePermittedRole.Amministrativo,
        RoutePermittedRole.Freelancer,
      ],
      state: {},
    },
  ],
}

const ZoneMenu: NavItemProps = {
  id: 'GestioneZone',
  title: 'Zone',
  messageId: '_hp.zone.sidebarGroupLabel',
   type: 'collapse',
//  type: 'group',
  icon: <MdOutlineMap/>,
  auth: [
    RoutePermittedRole.Gestore,
  ],
  state: {},
  children: [
    {
      id: 'ListaZone',
      title: 'ElencoZone',
      messageId: '_hp.listaZone.sidebarGroupLabel',
      type: 'item',
      url: '/elencoZone',
      icon: <BiSearchAlt/>,
      auth: [
        RoutePermittedRole.Gestore,
      ],
      state: {},
    },
    {
      id: 'AddZona',
      title: 'AggiungiZona',
      messageId: '_hp.aggiungiZona.sidebarGroupLabel',
      type: 'item',
      url: '/aggiungiZona',
      icon: <IoAdd/>,
      auth: [
        RoutePermittedRole.Gestore,
      ],
      state: {},
    }
  ]
}
const routesConfig: NavItemProps[] = [
  /*
    {
    id: 'Login',
    title: 'Login',
    messageId: '_hp.login.sidebarLabel',
    type: 'item',
    url: '/login',
    icon: 'user',
  },
  {
    id: 'Register',
    title: 'Register',
    messageId: '_hp.register.sidebarLabel',
    type: 'item',
    url: '/register',
    icon: 'user',
  },
   */
  {
    id: 'Home',
    title: 'Home',
    messageId: '_hp.common.home',
    type: 'item',
    url: '/Home',
    icon: <MdHome />,
    auth: [
      RoutePermittedRole.Gestore,
      RoutePermittedRole.Dipendente,
      RoutePermittedRole.Amministrativo,
      RoutePermittedRole.Freelancer,
    ],
    state: {},
  },
  {
    id: 'Profilo',
    title: 'Profilo',
    messageId: '_hp.myProfile.sidebarLabel',
    type: 'item',
    url: '/Profilo',
    icon: <MdOutlineManageAccounts />,
    auth: [
      RoutePermittedRole.Gestore,
      RoutePermittedRole.Dipendente,
      RoutePermittedRole.Amministrativo,
      RoutePermittedRole.Freelancer,
    ],
    state: {},
  },
  /*{
    id: 'ServiceList',
    title: 'Service List',
    messageId: '_hp.serviceList.sidebarLabel',
    type: 'item',
    url: '/elencoPrestazioni',
    icon: 'user',
    auth: ['user']
  },*/
  /* {
     id: 'PartnerList',
     title: 'Partner List',
     messageId: '_hp.serviceList.sidebarLabel',
     type: 'item',
     url: '/listaPartners',
     icon: 'user',
     auth: ['user']
   },*/

  // {
  //   id: 'Users',
  //   title: 'Gestione Utenti',
  //   messageId: '_hp.gestione.sidebarGroupLabel',
  //   type: 'group',
  //   icon: 'user',
  //   auth: [
  //     RoutePermittedRole.Gestore,
  //     RoutePermittedRole.Amministrativo,
  //   ],
  //   state: {},
  //   children: [],
  // },
  {
    id: 'Assistiti',
    title: 'Assistiti',
    messageId: '_hp.assistiti.sidebarGroupLabel',
    type: 'collapse',
    icon: <BsFillFileEarmarkPersonFill />,
    auth: [
      RoutePermittedRole.Gestore,
      RoutePermittedRole.Amministrativo,
      RoutePermittedRole.Freelancer,
    ],
    state: {},
    children: [
      {
        id: 'ListaAssistiti',
        title: 'Lista Assistiti',
        messageId: '_hp.assistiti.list.sidebarGroupLabel',
        type: 'item',
        url: '/elencoAssistiti',
        icon: <BiSearchAlt />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
        ],
        state: {},
      },
      {
        id: 'RegistraAssistito',
        title: 'Registra Assistito',
        messageId: '_hp.assistiti.add.sidebarGroupLabel',
        type: 'item',
        url: '/registraAssistito',
        icon: <IoAdd />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
        ],
        state: {},
      },
    ],
  },
  {
    id: 'UtentiList',
    title: 'Elenco Utenti',
    messageId: '_hp.gestioneUtenti.sidebarGroupLabel',
    type: 'collapse',
    icon: <FiUsers />,
    auth: [RoutePermittedRole.Gestore, RoutePermittedRole.Amministrativo],
    state: {},
    children: [
      {
        id: 'UtentiList',
        title: 'Utenti List',
        messageId: '_hp.listaUtenti.sidebarLabel',
        type: 'item',
        url: '/elencoUtenti',
        icon: <BiSearchAlt />,
        auth: [RoutePermittedRole.Gestore, RoutePermittedRole.Amministrativo],
        state: {},
      },
      {
        id: 'UtenteRegister',
        title: 'Utenti Register',
        messageId: '_hp.registraUtenti.sidebarLabel',
        type: 'item',
        url: '/registraUtente',
        icon: <IoAdd />,
        auth: [RoutePermittedRole.Gestore, RoutePermittedRole.Amministrativo],
        state: {
          cognome: '',
          nome: '',
          email: '',
          cellulare: '',
          ruoli: '',
          idPartners: [],
          idProfessioni: [],
          action: '',
        },
      },
      {
        id: 'FigureProfessionali',
        title: 'Figure Professionali',
        messageId: '_hp.figureProfessionali.sidebarLabel',
        type: 'item',
        url: '/figureProfessionali',
        icon: <ImProfile />,
        auth: [RoutePermittedRole.Gestore],
        state: {},
      },
    ],
  },
  AreaPartnerMenu,
  PartnersMenu,
  ZoneMenu,
  {
    id: 'GestionePrestazioni',
    title: 'Gestione Prestazioni',
    messageId: '_hp.gestionePrestazioni.sidebarGroupLabel',
    type: 'collapse',
    // type: 'group',
    icon: <FaBriefcaseMedical />,
    auth: [RoutePermittedRole.Gestore],
    state: {},
    children: [
      {
        id: 'PrestazioneList',
        title: 'Prestazione List',
        messageId: '_hp.listaPrestazioni.sidebarLabel',
        type: 'item',
        url: '/elencoPrestazioni',
        icon: <BiSearchAlt />,
        auth: [RoutePermittedRole.Gestore],
        state: {},
      },
      {
        id: 'PrestazioneAdd',
        title: 'Add Prestazione',
        messageId: '_hp.addPrestazione.sidebarLabel',
        type: 'item',
        url: '/aggiungiPrestazione',
        icon: <IoAdd />,
        auth: [RoutePermittedRole.Gestore],
        state: {},
      },
    ],
  },
  {
    id: 'ElencoDispositivi',
    title: 'Elenco Dispositivi',
    messageId: '_hp.gestioneDispositivi.sidebarGroupLabel',
    type: 'item',
    url: '/elencoDispositivi',
    icon: <TbDeviceHeartMonitor />,
    auth: [
      RoutePermittedRole.Gestore,
      RoutePermittedRole.Amministrativo,
      RoutePermittedRole.CentraleOperativa,
      RoutePermittedRole.Freelancer,
    ],
    state: {},
  },
  // {
  //   id: 'HomePoints',
  //   title: 'Home Points',
  //   messageId: '_hp.homepoints.sidebarGroupLabel',
  //   type: 'collapse',
  //   icon: <RiHeartPulseLine/>,//icona
  //   auth: [
  //     RoutePermittedRole.Gestore,
  //     RoutePermittedRole.Amministrativo,
  //     RoutePermittedRole.Freelancer,
  //   ],
  //   state: {},
  //   children: [
  //     {
  //       id: 'ListHomePoints',
  //       title: 'Home Points List',
  //       messageId: '_hp.homepoints.list.sidebarGroupLabel',
  //       type: 'item',
  //       url: '/elencoAmbulatori',
  //       icon: <BiSearchAlt/>,
  //       auth: [
  //         RoutePermittedRole.Gestore,
  //         RoutePermittedRole.Amministrativo,
  //         RoutePermittedRole.Freelancer,
  //       ],
  //       state: {},
  //     },
  //     {
  //       id: 'NewHomePoint',
  //       title: 'New Home Point',
  //       messageId: '_hp.homepoints.new.sidebarGroupLabel',
  //       type: 'item',
  //       url: '/aggiungiAmbulatorio',
  //       icon: <IoAdd/>,
  //       auth: [
  //         RoutePermittedRole.Gestore,
  //         RoutePermittedRole.Amministrativo,
  //         RoutePermittedRole.Freelancer,
  //       ],
  //       state: {},
  //     }],
  // },

  {
    id: 'CUP',
    title: 'CUP',
    messageId: '_hp.CUP.sidebarGroupLabel',
    type: 'collapse',
    // type: 'group',
    icon: <MdHeadsetMic />,
    auth: [
      RoutePermittedRole.Gestore,
      RoutePermittedRole.CentraleOperativa,
      RoutePermittedRole.Amministrativo,
      RoutePermittedRole.Freelancer,
    ],
    state: {},
    children: [
      {
        id: 'Booking',
        title: 'Booking',
        messageId: '_hp.CUP.booking.sidebarGroupLabel',
        type: 'item',
        url: '/CupBooking',
        icon: <BsBookmarkCheckFill />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
        ],
        state: {},
      },
      {
        id: 'Prenotazioni',
        title: 'Prenotazioni',
        messageId: '_hp.CUP.prenotazioni.sidebarGroupLabel',
        type: 'item',
        url: '/elencoPrenotazioni',
        icon: <MdOutlineEventNote />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
        ],
        state: {},
      },
      {
        id: 'RichiestePrenotazioni',
        title: 'RichiestePrenotazioni',
        messageId: '_hp.CUP.richiestePrenotazioni.sidebarGroupLabel',
        type: 'item',
        url: '/richiestePrenotazioni',
        icon: <FaClipboardList />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
          RoutePermittedRole.CentraleOperativa,
        ],
        state: {},
      },
      {
        id: 'AgendaRichieste',
        title: 'AgendaRichieste',
        messageId: '_hp.CUP.agendaRichiestePrenotazioni.sidebarGroupLabel',
        type: 'item',
        url: '/agendaDomiciliare',
        icon: <FaClipboardList />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
          RoutePermittedRole.CentraleOperativa,
        ],
        state: {},
      },
      {
        id: 'AddRichiestaPrenotazione',
        title: 'Add Richiesta Prenotazione',
        messageId: '_hp.addListaAttesa.sidebarGroupLabel',
        type: 'item',
        url: '/inserisciRichiestaPrenotazione',
        icon: <IoAdd />,
        auth: [
          RoutePermittedRole.Gestore,
          RoutePermittedRole.Amministrativo,
          RoutePermittedRole.Freelancer,
        ],
        state: {},
      },
    ],
  },

  // {
  //   id: 'dipendente',
  //   title: 'Menu',
  //   messageId: '_hp.common.menu',
  //   type: 'group',
  //   icon: 'user',
  //   auth: [RoutePermittedRole.Dipendente],
  //   state: {},
  //   children: [
  //     {
  //       id: 'Prenotazioni',
  //       title: 'Prenotazioni',
  //       messageId: '_hp.CUP.prenotazioni.sidebarGroupLabel',
  //       type: 'item',
  //       url: '/elencoPrenotazioni',
  //       icon: <MdOutlineEventNote />,
  //       auth: [RoutePermittedRole.Dipendente],
  //       state: {},
  //     },
  //   ],
  // },
  {
    id: 'Prenotazioni',
    title: 'Prenotazioni',
    messageId: '_hp.CUP.prenotazioni.sidebarGroupLabel',
    type: 'item',
    url: '/elencoPrenotazioni',
    icon: <MdOutlineEventNote />,
    auth: [RoutePermittedRole.Dipendente],
    state: {},
  },
  /*
  {
    id: 'ListaPersoneACarico',
    title: 'Persone a carico',
    messageId: '_hp.personeACarico.sidebarLabel',
    type: 'item',
    url: '/personeACarico',
    icon: 'user',
    auth: ['user']
  }/*
  {
    id: 'sample',
    title: 'Sample',
    messageId: 'sidebar.sample',
    type: 'collapse',
    icon: 'dashboard',
    children: [
      {
        id: 'page-1',
        title: 'Page -1',
        messageId: 'sidebar.sample.page1',
        type: 'item',
        url: '/sample/page-1',
      },
      {
        id: 'page-2',
        title: 'Page -2',
        messageId: 'sidebar.sample.page2',
        type: 'item',
        url: '/sample/page-2',
      },
    ],
  },*/
];
export default routesConfig;
